import { defineComponent as _defineComponent } from 'vue'
import { watch, ref, provide, computed, onMounted } from 'vue'
  import GenericContent from '@/components/curated-content/GenericContent.vue'
  import SearchApi from '@/services/api/SearchApi'
  import useSegment from '@/composables/useSegment'
  import SearchLoader from '@/components/loaders/SearchLoader.vue'
  import { useRoute } from 'vue-router/composables'
  import useI18n from '@/composables/useI18n'
  import type { Nullable } from '@/services/interfaces/Folder'
  import type { CourseSearchItem } from '@/services/interfaces/Course'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResults',
  setup(__props) {

  const route = useRoute()
  const { trackPage, pageViewed } = useSegment()
  const { translateString } = useI18n()
  const { setIsLoadingComponentViewData } = useCommonMixin()

  const searchResults = ref(null as Nullable<CourseSearchItem[]>)
  const limit = 10
  provide('itemPurpose', 'search-result')

  const isLoading = computed(() => {
    return searchResults.value === null
  })

  const term = computed(() => {
    return (route.query.q as string) || ''
  })

  const headlineCopy = computed(() => {
    if (!searchResults.value?.length) return `${translateString('search.topResultsText')} "${term.value}"`
    return `${searchResults.value.length} ${translateString('search.resultsText')} "${term.value}"`
  })

  const routeQuery = computed((): { q: string } => {
    return route.query as { q: string }
  })

  const findSearchTerm = (term: string) => {
    searchResults.value = null
    SearchApi.search(term).then((data) => {
      searchResults.value = data as CourseSearchItem[]
    })
  }

  onMounted(() => {
    trackPage('Search Results')
    pageViewed('Search Results')
  })

  watch(routeQuery, (query: { q: string }) => {
    if (query.q) {
      findSearchTerm(query.q)
    }
  })

  watch(isLoading, (value) => {
    setIsLoadingComponentViewData(value)
  })

  findSearchTerm(term.value)

return { __sfc: true,route, trackPage, pageViewed, translateString, setIsLoadingComponentViewData, searchResults, limit, isLoading, term, headlineCopy, routeQuery, findSearchTerm, watch, ref, provide, computed, onMounted, GenericContent, SearchApi, useSegment, SearchLoader, useRoute, useI18n, useCommonMixin }
}

})